import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect } from 'react';
import s from './index.less'

export default function Message (props) {
    useStyles(s);

    const timeTransition = () => {
        let count = 2;
        const end = setInterval(function () {
            if (count <= 1) {
                clearInterval(end);
                props.closeMessage();
            }
            count--;
        }, 1000);
    }

    useEffect(() => {
        if (props.visible) {
            timeTransition();
        }
    }, [props.visible]);

    return (
        <div className={props.visible ? "message show animation" : "message animation"}>
            <div className="message-notice">
                <div className="message-notice-content">
                    <i className="iconfont icon-share">&#xe7a7;</i>
                    <span>{props.txt}</span>
                </div>
            </div>
        </div>
    )
}